import baseLayout from '@elegantstack/solid-ui-theme/src/layout'

export default {
  ...baseLayout,
  table: {
    overflowX: 'auto'
  }
}
